import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import SignUpDialog from "@/components/SignUpDialog";

const CallToAction = () => {
  const [signUpOpen, setSignUpOpen] = useState(false);
  return (
    <>
    <SignUpDialog open={signUpOpen} onOpenChange={setSignUpOpen} />
    <section className="py-24 bg-background relative">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative bg-card border border-border rounded-2xl p-10 md:p-16 text-center overflow-hidden shadow-card"
        >
          {/* Glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[200px] bg-primary/10 blur-[100px] rounded-full" />
          
          <div className="relative z-10">
            <h2 className="font-display text-3xl md:text-5xl font-bold mb-6">
              Ready to put a government affairs <span className="text-gradient-primary">partner in the room?</span>
            </h2>
            <p className="text-muted-foreground text-lg max-w-xl mx-auto mb-10 leading-relaxed">
              Get started with our team. We'll walk through the bills, coalitions, research, and capital relevant to your work — and where we'd plug in.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-display font-semibold text-base px-10 shadow-glow" onClick={() => setSignUpOpen(true)}>
                Get Started <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
              <Button size="lg" variant="outline" className="border-border text-foreground hover:bg-secondary font-display text-base px-10" asChild>
                <a href="mailto:info@emrkt.co">Engage Our Firm</a>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
    </>
  );
};

export default CallToAction;
